import { render } from "./FindDuplicates.vue?vue&type=template&id=4df53031&scoped=true"
import script from "./FindDuplicates.vue?vue&type=script&lang=js"
export * from "./FindDuplicates.vue?vue&type=script&lang=js"

import "./FindDuplicates.vue?vue&type=style&index=0&id=4df53031&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df53031"]])

export default __exports__